import { Flex, Typography } from "antd";
import React, { useCallback, useEffect, useMemo } from "react";
import {
  StyledForgotPasswordCard,
  StyledForgotPasswordModal,
  StyledForgotPasswordSubtitle,
} from "./index.styled";
import { MdOutlineCancel } from "react-icons/md";
import { TbMailForward } from "react-icons/tb";
import PropTypes from "prop-types";
import AppVerifyCode from "_lib/AppVerifyCode";
import { useState } from "react";
import ForgotPasswordEmailStep from "./ForgotPasswordEmailStep";
import ForgotPasswordNewPasswordStep from "./ForgotPasswordNewPasswordStep";
import { CustomerManagementOTPPurposeEnum } from "_constants";

const ForgotPassword = (props) => {
  const { toggle, open = false } = props;

  const [step, setStep] = useState(forgotPasswordSteps.EnterEmail);
  const [email, setEmail] = useState(null);

  const next = useCallback(
    (nextStep) => () => {
      setStep(nextStep);
    },
    []
  );

  const onClear = useCallback(() => {
    setStep(forgotPasswordSteps.EnterEmail);
    setEmail(null);
  }, []);

  useEffect(() => {
    if (open) {
      onClear();
    }
  }, [onClear, open]);

  const onClose = useCallback(() => {
    onClear();
    toggle();
  }, [onClear, toggle]);

  const verifyCodePayload = useMemo(() => {
    let payload = {};
    payload.email = email;
    payload.purpose = CustomerManagementOTPPurposeEnum.ForgotPassword;
    return payload;
  }, [email]);

  const subtitle = useMemo(() => {
    let currentSubtitle = "No worries, it happens to the best of us!";
    if (step === forgotPasswordSteps.VerifyEmail) {
      currentSubtitle = `We've sent a code to ${email}`;
    }
    if (step === forgotPasswordSteps.NewPassword) {
      currentSubtitle =
        "Your new password must be different from previous used password";
    }
    return currentSubtitle;
  }, [email, step]);

  return (
    <StyledForgotPasswordModal
      open={open}
      centered
      footer={null}
      closable={false}
      width={420}
    >
      <Flex gap={12} vertical justify="center" align="center">
        <MdOutlineCancel size={24} onClick={onClose} />
        <Title level={5}>Forgot Password</Title>
        <StyledForgotPasswordSubtitle type="secondary">
          {subtitle}
        </StyledForgotPasswordSubtitle>
        {step === forgotPasswordSteps.EnterEmail && (
          <ForgotPasswordEmailStep
            next={next(forgotPasswordSteps.VerifyEmail)}
            setEmail={setEmail}
          />
        )}

        {step === forgotPasswordSteps.VerifyEmail && (
          <AppVerifyCode
            payload={verifyCodePayload}
            next={next(forgotPasswordSteps.NewPassword)}
          />
        )}
        {step === forgotPasswordSteps.NewPassword && (
          <ForgotPasswordNewPasswordStep email={email} next={onClose} />
        )}
        <StyledForgotPasswordCard vertical gap={12} justify="center">
          <Text strong>Need Some Help</Text>
          <Flex gap={12} align="center">
            <TbMailForward size={24} />
            <Flex vertical>
              <Text>Email Us</Text>
              <Text>Contact us via email</Text>
            </Flex>
          </Flex>
        </StyledForgotPasswordCard>
      </Flex>
    </StyledForgotPasswordModal>
  );
};

const { Text, Title } = Typography;

const forgotPasswordSteps = {
  EnterEmail: 1,
  VerifyEmail: 2,
  NewPassword: 3,
};

ForgotPassword.propTypes = {
  toggle: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default ForgotPassword;
